// src/hooks/useWarehouses.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { WarehouseService } from '../admin/pages/warehouse/warehouseService';

export const WAREHOUSE_KEYS = {
  all: ['warehouses'] as const,
  lists: () => ['warehouses', 'list'] as const,
  paginated: (page: number, search: string, status: string) =>
    ['warehouses', 'list', page, search, status] as const,
  stats: () => ['warehouses', 'stats'] as const,
};

// FIX: Removed the `cursors` field — seek-based pagination only needs `page`.
export interface WarehousePaginationParams {
  page: number;
  search: string;
  status: string;
  pageSize: number;
  // `cursors` intentionally removed — seek-based pagination uses only `page`
}

// FIX: Passes `params.page` directly to getWarehousesPaginated instead of
// cursor objects. Any page can now be fetched in any order.
export const useWarehousesPaginated = (params: WarehousePaginationParams) => {
  return useQuery({
    queryKey: WAREHOUSE_KEYS.paginated(params.page, params.search, params.status),
    queryFn: () =>
      WarehouseService.getWarehousesPaginated(
        params.pageSize,
        params.page,
        params.search || undefined,
        params.status !== 'all' ? params.status === 'active' : undefined
      ),
    staleTime: 1000 * 60 * 3,
    placeholderData: (prev: any) => prev,
  });
};

export const useWarehouseStats = () => {
  return useQuery({
    queryKey: WAREHOUSE_KEYS.stats(),
    queryFn: WarehouseService.getWarehouseStats.bind(WarehouseService),
    staleTime: 1000 * 60 * 5,
  });
};